// Renders a READ-ONLY value cell for the Rules / Reference tables.
//
// Booleans render as plain coloured text with a tick/dash, NOT as a filled
// pill. The filled pill is reserved for the cells you can actually click —
// Incl/Excl and the frozen Yes/No switches (OT Recalc, Training / Drug Screen
// billability). They used to look identical, which made computed columns like
// `matched` read as broken buttons (reported 2026-07-31). Colour still carries
// the value; the absent chip is what signals "not a control".
export function formatValue(value, key) {
  if (value === null || value === undefined) return <span style={{ color: '#ccc' }}>—</span>;
  if (typeof value === 'boolean') {
    return value
      ? <span className="cell-flag yes"><span className="cell-flag-mark">✓</span>Yes</span>
      : <span className="cell-flag no"><span className="cell-flag-mark">–</span>No</span>;
  }
  if (typeof value === 'number' && !key.includes('id')) {
    return value > 0
      ? <span style={{ fontWeight: 600, color: '#155724' }}>{value.toLocaleString()}</span>
      : <span style={{ color: '#999' }}>0</span>;
  }
  return String(value);
}
